import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-premioprinc',
	templateUrl: './premioprinc.component.html',
	styleUrls: ['./premioprinc.component.scss']
})
export class PremioprincComponent implements OnInit { isSmallScreen: boolean;

	title2 = 'Premios del Sorteo Anáhuac 2026 - 11ª Edición. !Participa y gana!';
	description = ''
	utmUrl = "";
	urlMicrositio =environment.URL_MICROSITIO;

	
	premios = [
		{
		  id: 'carSlider1',
		  title: 'DEPARTAMENTO',
		  subtitle: 'AMUEBLADO',
		  place: 'BREZZA TOWERS MAR',
		  subplace: 'CANCÚN',
		  price: 'VALOR + DE 13.5 MILLONES',
		  imagenes: [
			'uBnx5wc2ak0',
		  ],
		  number: '1° Premio'
		},
		{
		  id: 'carSlider2',
		  title: 'DEPARTAMENTO',
		  subtitle: 'AMUEBLADO',
		  place: 'BOSQUE REAL FIVE',
		  subplace: 'EDO. MÉXICO',
		  price: 'VALOR + DE 13.0 MILLONES',
		  imagenes: [
			'Jy0gqr5tZTo',
		  ],
		  number: '2° Premio'
		},
		{
		  id: 'carSlider3',
		  title: 'CASA',
		  subtitle: 'AMUEBLADA',
		  place: 'EL ORIGEN ',
		  subplace: 'MÉRIDA',
		  price: 'VALOR + DE 8 MILLONES',
		  imagenes: [
			'z6AfSQpbY58',
		  ],
		  number: '3° Premio'
		},
		{
		  id: 'carSlider4',
		  title: 'CASA',
		  subtitle: 'AMUEBLADA',
		  place: 'ZIBATÁ',
		  subplace: 'QUERÉTARO',
		  price: 'VALOR + DE 5.3 MILLONES',
		  imagenes: [
			'KU9UpsM5nd8',
		  ],
		  number: '4° Premio'
		},
		{
		  id: 'carSlider5',
		  title: 'CASA', 
		  subtitle:'AMUEBLADA', 
		  place: 'EL CAPRICHO', 
		  subplace:'PUEBLA', 
		  price: 'VALOR + DE 5.1 MILLONES', 
		  imagenes: [
			'd88f4fnKrHs',
		  ],
		  number: '5° Premio'
		},
	  ];

	/* galerías de los inmuebles (1° al 5° premio) */
	galerias = [
		{ titulo: '1° Premio · Edo. México', carpeta: 'premio1', total: 8 },
		{ titulo: '2° Premio · Cancún', carpeta: 'premio2', total: 9 },
		{ titulo: '3° Premio · Mérida', carpeta: 'premio3', total: 7 },
		{ titulo: '4° Premio · Puebla', carpeta: 'premio4', total: 9 },
		{ titulo: '5° Premio · Querétaro', carpeta: 'premio5', total: 10 },
	].map(g => ({
		...g,
		imagenes: Array.from({ length: g.total }, (_, i) => `assets/images/sorteo2026/inmuebles/${g.carpeta}/${i + 1}.jpg`)
	}));
	galeriaActiva: any = null;
	fotoActiva = 0;


	constructor(private router: Router, private titleService: Title, private metaTagService: Meta, private renderer: Renderer2, private elementRef: ElementRef, private modalService: NgbModal) {

	}

	abrirGaleria(index: number, modal: any): void {
		this.galeriaActiva = this.galerias[index];
		this.fotoActiva = 0;
		this.modalService.open(modal, { size: 'xl', centered: true, windowClass: 'modal-galeria' });
	}



	

	ngOnInit(): void {
		//(<any>$('#modalVideoPremios')).modal('show');
		/* videos */




		/*utm */
		let utmTem = localStorage.getItem('urlUtm');
		if (utmTem) this.utmUrl = utmTem;
		/* fin utm */
		this.titleService.setTitle(this.title2);
		this.metaTagService.updateTag(
			{ name: 'title', content: this.title2 }
		);
		this.metaTagService.updateTag(
			{ name: 'description', content: this.description }
		);

		this.metaTagService.updateTag(
			{ property: 'keywords', content: '' }
		);

		this.metaTagService.updateTag(
			{ property: 'og:title', content: this.title2 }
		);

		this.metaTagService.updateTag(
			{ property: 'og:description', content: this.description }
		);

		this.metaTagService.updateTag(
			{ property: 'og:url', content: environment.URL_WEB + '/premios-sorteo-anahuac' }
		);

		this.metaTagService.updateTag(
			{ property: 'og:image', content: environment.URL_WEB + '/assets/images/award1/primer-lugar.jpg' }
		);

		this.metaTagService.updateTag(
			{ name: 'twitter:title', content: this.title2 }
		);
		this.metaTagService.updateTag(
			{ name: 'twitter:description', content: this.description }
		);
	}





}


